import axios from "axios";
import history from "../history";
import { API_URL } from "./config";
import { getAccessToken } from "src/utils/tokenManager";
import localStorage from "src/utils/localStorage";
import { Alert, Box, Typography, Button, Modal } from "@material-ui/core";

const endpoint = API_URL;

/*-----------------------------GET ALL----------------------------------------*/
export function index(api_name, params, callback) {
  let _apiUrl = endpoint + api_name;
  let _headers = setHeaders();
  let _params = setParams(params);
  let _authorization = localStorage.getItem("_UID");
  axios.defaults.headers.common["uthorization"] = _authorization;

  axios
    .get(_apiUrl, _params, _headers)
    .then(function (response) {
      callback(response.data);
    })
    .catch((error) => {
      catchError(error);
    });
}

/*-----------------------------GET ONE----------------------------------------*/
export function show(api_name, id, params, callback) {
  let _apiUrl = endpoint + api_name + "/" + id;
  let _headers = setHeaders();
  let _params = setParams(params);
  let _authorization = localStorage.getItem("_UID");
  axios.defaults.headers.common["Authorization"] = _authorization;

  axios
    .get(_apiUrl, _params, _headers)
    .then(function (response) {
      callback(response.data);
    })
    .catch((error) => {
      catchError(error);
    });
}

/*-----------------------------POST-------------------------------------------*/
export function create(api_name, params, callback) {
  let _apiUrl = endpoint + api_name;
  let _headers = setHeaders();
  let _params = JSON.stringify(params);
  let _authorization = localStorage.getItem("_UID");
  axios.defaults.headers.common["Authorization"] = _authorization;

  axios
    .post(_apiUrl, _params, _headers)
    .then(function (response) {
      callback(response.data);
    })
    .catch((error) => {
      catchError(error);
    });
}

export function del(api_name, id, params, callback) {
  let _apiUrl = endpoint + api_name + "/" + id;
  let _headers = setHeaders();
  let _params = setParams(params);
  let _authorization = localStorage.getItem("_UID");
  axios.defaults.headers.common["Authorization"] = _authorization;

  axios
    .delete(_apiUrl, _params, _headers)
    .then(function (response) {
      callback(response.data);
    })
    .catch((error) => {
      throw error;
    });
}

/*-----------------------------SIGIN------------------------------------------*/
export function signIn(api_name, params, callback) {
  let _apiUrl = endpoint + api_name;
  let _headers = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  };
  let _params = JSON.stringify(params);

  axios
    .post(_apiUrl, _params, _headers)
    .then(function (response) {
      let data = response.data;
      callback(data);
    })
    .catch((error) => {
      catchError(error);
    });
}

/*-----------------------------PUT--------------------------------------------*/
export function update(api_name, id, params, callback) {
  let _apiUrl = endpoint + api_name + "/" + id;
  if (id === "") {
    _apiUrl = endpoint + api_name;
  }
  let _headers = setHeaders();
  let _params = JSON.stringify(params);
  let _authorization = localStorage.getItem("_UID");
  axios.defaults.headers.common["Authorization"] = _authorization;

  axios
    .put(_apiUrl, _params, _headers)
    .then(function (response) {
      callback(response.data);
    })
    .catch((error) => {
      catchError(error);
    });
}

/*-----------------------------UPLOAD IMAGE-----------------------------------*/
export function uploadImages(api_name, params, files, callback) {
  let _apiUrl = endpoint + api_name;
  let formData = new FormData();
  let _authorization = localStorage.getItem("_UID");
  axios.defaults.headers.common["Authorization"] = _authorization;

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const val = params[key];
      formData.append(key, val);
    }
  }

  let i = 0;
  for (i = 0; i < files.length; i++) {
    let file = files[i];
    formData.append("images[]", file, file.name);
  }

  axios
    .post(_apiUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(function (response) {
      callback(response.data);
    })
    .catch((error) => {
      throw error;
    });
}

/*-----------------------------SET HEADERS------------------------------------*/
export function setHeaders() {
  let _authorization = localStorage.getItem("_UID");
  let _axios_header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: _authorization,
    },
  };
  return _axios_header;
}

/*-----------------------------SET PARAMS-------------------------------------*/
export function setParams(params) {
  let axios_params = {
    params: params,
  };
  return axios_params;
}

export async function withAccessToken(params) {
  return {
    ...params,
    Authorization: `Bearer ${await getAccessToken()}`,
  };
}

export function catchError(error, open, onClose, style) {
  if (error.response !== undefined) {
    const _status = error.response.status;

    if (_status !== 200) {
      if (_status === 408) {
        <Modal
          hideBackdrop
          open={open}
          onClose={onClose}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={{ ...style, width: 200 }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <Alert severity="warning">Thông báo</Alert>
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {error.response.data.message}
            </Typography>
            <Button
              onClick={() => {
                history.push("/login");
                window.location.reload(true);
              }}
            >
              Ok
            </Button>
          </Box>
        </Modal>;
      } else {
        <Modal
          hideBackdrop
          open={open}
          onClose={onClose}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={{ ...style, width: 200 }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <Alert severity="warning">Thông báo</Alert>
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {error.response.data.message}
            </Typography>
          </Box>
        </Modal>;
      }
    }
  } else {
    <Modal
      hideBackdrop
      open={open}
      onClose={onClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box sx={{ ...style, width: 200 }}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          <Alert severity="error">Error</Alert>
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          System error
        </Typography>
      </Box>
    </Modal>;
  }
}
